export default __webpack_public_path__ + "static/media/xp.1292e9fc.png";